function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Monitor as BaseMonitor, DisconnectedError } from '@anycable/core';
export var Monitor = /*#__PURE__*/function (_BaseMonitor) {
  _inherits(Monitor, _BaseMonitor);

  var _super = _createSuper(Monitor);

  function Monitor() {
    _classCallCheck(this, Monitor);

    return _super.apply(this, arguments);
  }

  _createClass(Monitor, [{
    key: "watch",
    value: function watch(cable) {
      _get(_getPrototypeOf(Monitor.prototype), "watch", this).call(this, cable);

      this.initActivityListeners();
    }
  }, {
    key: "initActivityListeners",
    value: function initActivityListeners() {
      var _this = this;

      if (typeof document !== 'undefined' && typeof window !== 'undefined' && document.addEventListener && window.addEventListener) {
        var visibility = function visibility() {
          if (!document.hidden) {
            if (_this.reconnectNow()) {
              _this.logger.debug('Trigger reconnect due to visibility change');
            }
          }
        };

        var connect = function connect(event) {
          if (_this.reconnectNow()) {
            _this.logger.debug('Trigger reconnect', {
              event: event
            });
          }
        };

        var disconnectFrozen = function disconnectFrozen() {
          return _this.disconnect(new DisconnectedError('page_frozen'));
        };

        document.addEventListener('visibilitychange', visibility, false);
        window.addEventListener('focus', connect, false);
        window.addEventListener('online', connect, false);
        window.addEventListener('resume', connect, false);
        window.addEventListener('freeze', disconnectFrozen, false);
        this.unbind.push(function () {
          document.removeEventListener('visibilitychange', visibility, false);
          window.removeEventListener('focus', connect, false);
          window.removeEventListener('online', connect, false);
          window.removeEventListener('resume', connect, false);
          window.removeEventListener('freeze', disconnectFrozen, false);
        });
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect(err) {
      if (this.state === 'disconnected' || this.state === 'closed') return;
      this.logger.info('Disconnecting', {
        reason: err.message
      });
      this.cancelReconnect();
      this.stopPolling();
      this.state = 'pending_disconnect';
      this.target.disconnected(err);
    }
  }]);

  return Monitor;
}(BaseMonitor);